import React, { useMemo } from "react";
import { BarChart } from "@tremor/react";
import { Card } from "antd";
import dayjs from "dayjs";

import { useNutritionSummaryForRange } from "~/modules/Trainee/TraineeProfile/TraineeFeatures/TraineeResults/hooks/useMeasurementsForRange";
import { type CommonChartProps } from "~/modules/Trainee/TraineeProfile/TraineeFeatures/TraineeResults/types";

const valueFormatterAbsolute = (number: number) => `${Intl.NumberFormat("pl").format(number).toString()} kcal`;

export const NutritionCaloriesChart = ({ range }: CommonChartProps): React.ReactElement => {
  const { data: measurements = [], isInitialLoading } = useNutritionSummaryForRange(range);

  const chartData = useMemo(() => {
    const items = measurements.map((item) => item.data).flat();
    return items.map((item) => ({
      date: dayjs(item.eventDate).format("DD.MM.YYYY"),
      Kalorie: item.calories,
    }));
  }, [measurements]);

  return (
    <Card title="Spożyte kalorie" type="inner" className="relative" loading={isInitialLoading}>
      <BarChart
        className="mt-8 h-80"
        data={chartData}
        index="date"
        colors={["rose"]}
        categories={["Kalorie"]}
        showLegend={false}
        valueFormatter={valueFormatterAbsolute}
        yAxisWidth={90}
        allowDecimals={false}
        intervalType={"preserveStartEnd"}
        noDataText="Brak danych do wyświetlenia"
      />
    </Card>
  );
};
